const Button = ({ dataCbType, dataCbItem = '', onClick, isBestValue, children, style, disabled = false }) => {
	return (
		<div style={{ width: '100%' }}>
			<button
				data-cb-type={dataCbType}
				data-cb-item-0={dataCbItem}
				onClick={onClick}
				style={style}
				disabled={disabled}
				className={`get-started ${isBestValue && 'best-value-btn'}`}
			>
				{children}
			</button>
		</div>
	);
};

export default Button;
